import './style.css';
import React from 'react';
import RModal from 'react-modal';
var Modal = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, onClose = _a.onClose;
    return (React.createElement(RModal, { isOpen: isOpen, className: "syl-modal", shouldFocusAfterRender: true, onRequestClose: onClose, ariaHideApp: false, style: {
            content: {
                top: '20%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: '#fff',
                position: 'absolute',
                boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
                borderRadius: '4px',
            },
            overlay: {
                background: 'rgba(0, 0, 0, 0.5)',
                zIndex: 6,
            },
        } }, children));
};
var ModalTitle = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "syl-modal-title" }, children);
};
var ModalContent = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "syl-modal-content" }, children);
};
var ModalFooter = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "syl-modal-footer" }, children);
};
export { Modal, ModalContent, ModalFooter, ModalTitle };
//# sourceMappingURL=index.js.map